import React from 'react'
import '../../../styles/fontSizes.scss'
import "./circleButton.scss"
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const CircleButton = ({value, handle, textSize}) =>{
    return(
        <>
            <input onClick = {handle} value = {value} type = "button" className ={`circle-button__button font-size--${textSize?textSize:"1"}`}/>
        </>
    )
}

export default CircleButton;